export default function TentangKami(params) {
    return (
        <>
        <div className="p-4 lg:mx-16 w-full lg:w-1/2 mt-10 mb-48">
            <p className="text-4xl">Tentang Kami</p>
            <div className="text-smx font-serif mt-8">
                    <p className="mb-3">
                        Lini bisnis dari Energi Masa Depan, perusahaan jasa energi yang berkesinambungan yang berfokus pada pengembangan sistem solar energi.
                    </p>
                    <p className="mb-3">
                        Didirikan pada tahun 2020, dengan pengalaman pemasangan solar panel lebih dari 50Mwp di berbagai macam proyek dengan skala industri, komersial dan residential.
                    </p>
                    <p className="mb-3">
                        Mulai dari konsep, konstruksi, proses registrasi dan perizinan ke PLN, hingga metode pembayaran yang fleksibel, Energi Masa Depan berupaya untuk mewujudkan listrik hemat dan ramah lingkungan untuk Indonesia.
                    </p>
            </div>
        </div>
        </>
    )
}